module.exports = __webpack_public_path__ + "static/media/partiallyConfirmed-order.305374c2.svg";